import { Linking, Pressable } from 'react-native';

import { ReactNode } from 'react';
import { ASTNode } from 'react-native-markdown-display';
import { Text } from '../Text/Text';

export const renderRules = {
  link: (
    node: ASTNode,
    children: ReactNode[],
    parent: ASTNode[],
    styles: any,
  ) => (
    <Pressable onPress={() => Linking.openURL(node.attributes.href)}>
      {children.map((child: ReactNode, idx: number) => {
        if (typeof child === 'object') {
          return (
            <Text key={idx} style={{ ...styles.link }}>
              {(child as any)?.props?.children}
            </Text>
          );
        } else {
          return child;
        }
      })}
    </Pressable>
  ),
};
